export default __webpack_public_path__ + "static/media/upload_books_template.6d83fe2a.xls";